import { render, staticRenderFns } from "./Psychologists.vue?vue&type=template&id=3ffec2da&"
import script from "./Psychologists.vue?vue&type=script&lang=ts&"
export * from "./Psychologists.vue?vue&type=script&lang=ts&"
import style0 from "./Psychologists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports